/**
 * API category names as they appear in the search API.
 * These are the exact string values expected by the search API's category filter.
 */
export enum ApiCategory {
  SmallAppliances = 'Small Appliances',
  MajorAppliances = 'Major Appliances',
  ApparelShoesAndAccessories = 'Apparel Shoes & Accessories',
  AutomotiveSupplies = 'Automotive Supplies',
  BooksMoviesAndMusic = 'Books Movies & Music',
  BuildingAndIndustrial = 'Building & Industrial',
  CellPhones = 'Cell Phones',
  Electronics = 'Electronics',
  Furniture = 'Furniture',
  Groceries = 'Groceries',
  HealthAndBeauty = 'Health & Beauty',
  HomeAndGarden = 'Home & Garden',
  JewelryAndWatches = 'Jewelry & Watches',
  MixedLots = 'Mixed Lots',
  OfficeSuppliesAndEquipment = 'Office Supplies & Equipment',
  Pets = 'Pets',
  SportsAndOutdoors = 'Sports & Outdoors',
  ToysKidsAndBaby = 'Toys Kids & Baby',
}
